type Props = {
  icon?: string
  title: string
}
export default function FilterHeader({ icon, title }: Props) {
  return (
    <div className="flex gap-2 items-baseline lg:my-3">
      <div className="uppercase">
        <span className="font-bwi mr-1">{icon}</span>
        {title}
      </div>
    </div>
  )
}
